import type { UserRole, Membership } from "./api/types";

export function resolveRole(claimsRole: unknown, email?: string | null): UserRole {
  const roleStr = String(claimsRole);
  const rawEmails = (import.meta.env.VITE_PROGRAM_MANAGER_EMAILS as string) ?? "";
  const managerEmails = rawEmails
    .split(",")
    .map((e: string) => e.trim().toLowerCase());

  if (roleStr === "admin" || roleStr === "program_manager" || roleStr === "mentor" || roleStr === "learner") {
    return roleStr as UserRole;
  }

  if (email && managerEmails.includes(email.toLowerCase())) {
    return "program_manager";
  }

  return "unknown";
}

export function isManagerOrAbove(role: UserRole): boolean {
  return role === "admin" || role === "program_manager";
}

export function getMentorPLG(memberships: unknown): string | null {
  if (!Array.isArray(memberships)) return null;

  // A user may hold multiple memberships with different roles (e.g. mentor
  // of CKAD 015 and learner of CKAD 003). Pick the one where role === "mentor".
  for (const m of (memberships as Membership[])) {
    if (m && typeof m === "object") {
      const rec = m as Record<string, unknown>;
      const tag = rec.tag;
      if (rec.role === "mentor" && typeof tag === "string" && (tag.startsWith("KCNA-") || tag.startsWith("CKAD-"))) {
        return tag.replace("-", " ");
      }
    }
  }
  return null;
}
